/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { useProjectService, useProjectUrl } from 'domain/shared/project';
import ProjectForm from 'domain/projects/project/createupdate/ProjectForm';
import { CreateForm } from 'framework/form';
import CreateProjectBreadcrumbs from 'domain/projects/project/createupdate/Create/Breadcrumbs';

const CreateProject = () => {
  const { createProject, getValidationSchema } = useProjectService();
  const { getListUrl } = useProjectUrl();

  return (
    <CreateForm
      submitFormFunc={createProject}
      initialData={{}}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Project has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Project" breadcrumbs={<CreateProjectBreadcrumbs />}>
        <ProjectForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateProject;
